export enum StatusMessage {
    UnknownError = 'Unknown Error.',
    Unauthorized = 'Unauthorized access.',
    BadRequest = 'Bad request.',
    Forbidden = 'Forbidden access.',
    NotFound = 'Not found.',
    InternalServerError = 'Internal server error.',
}